export const AVAAIO_LANGUAGES = [
    {
        code: "en",
        label: "English",
        nativeLabel: "English",
        speechLocale: "en-US",
    },
    {
        code: "es",
        label: "Spanish",
        nativeLabel: "Español",
        speechLocale: "es-US",
    },
    {
        code: "fr",
        label: "French",
        nativeLabel: "Français",
        speechLocale: "fr-FR",
    },
    {
        code: "de",
        label: "German",
        nativeLabel: "Deutsch",
        speechLocale: "de-DE",
    },
    {
        code: "it",
        label: "Italian",
        nativeLabel: "Italiano",
        speechLocale: "it-IT",
    },
    {
        code: "pt",
        label: "Portuguese",
        nativeLabel: "Português",
        speechLocale: "pt-BR",
    },
];
const SUPPORTED = new Set(AVAAIO_LANGUAGES.map((item) => item.code));
export function normalizeAvaaioLanguage(value) {
    const normalized = String(value || "en")
        .trim()
        .toLowerCase()
        .replaceAll("_", "-")
        .split("-", 1)[0];
    return SUPPORTED.has(normalized)
        ? normalized
        : "en";
}
export function getInitialPreferredLanguage() {
    if (typeof window === "undefined") {
        return "en";
    }
    const stored = window.localStorage.getItem("ava_preferred_language") ||
        window.sessionStorage.getItem("ava_preferred_language") ||
        window.localStorage.getItem("ava_language") ||
        window.sessionStorage.getItem("ava_language");
    if (stored) {
        return normalizeAvaaioLanguage(stored);
    }
    return normalizeAvaaioLanguage(window.navigator.language);
}
export function persistPreferredLanguage(value) {
    const language = normalizeAvaaioLanguage(value);
    if (typeof window === "undefined") {
        return language;
    }
    const keys = [
        "ava_preferred_language",
        "ava_language",
        "ava_ui_language",
    ];
    for (const key of keys) {
        try {
            window.localStorage.setItem(key, language);
            window.sessionStorage.setItem(key, language);
        }
        catch {
            // Browser storage can be unavailable in private mode.
        }
    }
    document.documentElement.lang = language;
    window.dispatchEvent(new CustomEvent("avaaio-language-updated", {
        detail: {
            language,
        },
    }));
    return language;
}
